var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("settings")]),
          _vm._v(" " + _vm._s(_vm.$t("parametro.preferencias")))
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tabs",
        {
          staticClass: "tab-preferencias",
          attrs: { color: "info", dark: "", "slider-color": "warning" },
          model: {
            value: _vm.active,
            callback: function($$v) {
              _vm.active = $$v
            },
            expression: "active"
          }
        },
        [
          _c(
            "v-tab",
            { key: "sistemas", attrs: { href: "#sistemas", ripple: "" } },
            [_c("v-icon", [_vm._v("laptop")]), _vm._v(" Sistema\n      ")],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            { key: "roles", attrs: { href: "#roles", ripple: "" } },
            [
              _c("v-icon", [_vm._v("person_outline")]),
              _vm._v(" " + _vm._s(_vm.$t("rol.title")) + "\n      ")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            { key: "recursos", attrs: { href: "#recursos", ripple: "" } },
            [_c("v-icon", [_vm._v("menu")]), _vm._v(" Recursos\n      ")],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            { key: "sistemas", attrs: { value: "sistemas" } },
            [
              _c(
                "v-card",
                { attrs: { flat: "" } },
                [_vm.active == "sistemas" ? _c("sistema") : _vm._e()],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            { key: "roles", attrs: { value: "roles" } },
            [
              _c(
                "v-card",
                { attrs: { flat: "" } },
                [_vm.active == "roles" ? _c("rol") : _vm._e()],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            { key: "recursos", attrs: { value: "recursos" } },
            [
              _c(
                "v-card",
                { attrs: { flat: "" } },
                [_vm.active == "recursos" ? _c("recurso") : _vm._e()],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7424b64e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7424b64e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/rol-recurso/Index.vue
// module id = null
// module chunks = 